export default __webpack_public_path__ + "static/media/kheng-music1.7769a5be.jpg";